import axios from "axios";

import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/full_time`;

export const getFTUser = async (token, startDate, endDate, userId) => {
  let bodyRequest = {
    start_date: startDate,
    end_date: endDate,
    user_id: userId,
  };
  const response = await axios.post(`${API_URL}/user/`, bodyRequest, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteFTUser = async (token, idFT) => {
  const response = await axios.delete(`${API_URL}/${idFT}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const CreateFTUser = async (token) => {
  const response = await axios.post(`${API_URL}/create/`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const GetReportFT = async (token, startDate, endDate, restaurant_id) => {
  try {
    const response = await axios.get(
      `${MainUrl}/reports/full_time/?start_date=${startDate}&end_date=${endDate}&restaurant_id=${restaurant_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    // if (error.status == 401) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("access_level");
    //   window.location.href = "/";
    // }
    return error.response.data;
  }
};
